import { z } from "zod";

export const ConfigTypeList = [
  "String",
  "Integer",
  "Float",
  "Boolean",
  "Json",
  "List",
] as const;

export type ConfigType = (typeof ConfigTypeList)[number];

export const ConfigTopicList = [
  "GENERAL",
  "PLUGIN_CONFIG",
  "WEB_UI_SCOPE",
  "UI_CONFIG",
  "ANALYTICS",
  "FEATURE_TOGGLE",
] as const;

export type ConfigTopic = (typeof ConfigTopicList)[number];

export const ConfigurationKeyList = [
  "DASHBOARD_ID",
  "CURRENCY_FORMAT",
  "SHOP_CURRENCY",
  "PLUGIN_FULL_MODE",
  "SHOP_WEIGHT_UNIT",
  "SHOPIFY_PLAN",
  "ADDITIONAL_PRICE_QUERY_SELECTORS",
  "ADDITIONAL_VOLUME_DISCOUNT_QUERY_SELECTORS",
  "ADD_IG_DISCOUNT_TO_HREF_QUERY_SELECTORS",
  "ADDITIONAL_COMPARE_PRICE_QUERY_SELECTORS",
  "ADDITIONAL_INSTALLMENT_PRICE_QUERY_SELECTORS",
  "ADDITIONAL_CART_SAVINGS_SELECTORS",
  "ADDITIONAL_CART_ORIGINAL_TOTAL_SELECTORS",
  "ENABLE_AI",
  "SHADOW_ELEMENT_SELECTORS",
  "INTERCEPT_ATC_XHR",
  "SHOULD_REDIRECT",
  "PLUGIN_BRANCH",
  "SHOULD_DUPLICATE_PRODUCTS",
  "LAZY_CART_UPDATE",
  "EAGER_UPDATE_DOM",
  "ENABLE_SCHEDULE_TESTS",
  "UPDATE_VARIANTS_IN_ATC_FORM",
  "ADD_TEST_GROUP_ID",
  "SHIPPING_PROGRESS_BAR_CONFIG",
  "SHOULD_PULL_COST_FROM_SHOPIFY",
  "SHOULD_HIDE_SHIPPING_SUBTEXT",
  "LOCALE",
  "COUSINS_MAX_LEVELS_UP",
  "ADDITIONAL_SAVINGS_PRICE_QUERY_SELECTORS",
  "ADDITIONAL_SAVINGS_PERCENTAGE_QUERY_SELECTORS",
  "SHOULD_SHOW_PROFIT_IN_DASHBOARD",
  "SHOULD_SHOW_SITEWIDE_DASHBOARD",
  "SHOULD_SHOW_VOLUME_DISCOUNTS_DASHBOARD_FILTER",
  "IS_IG_INTEGRATION",
  "IS_PRICE_SCRAPER_SUBMITTED",
  "INTEGRATION_STATUS_MESSAGE",
  "SELF_INTEGRATION_STEP_STATUSES",
  "ENABLE_PRICE_CSV_DOWNLOAD",
  "CURRENCY_FUNCTION",
  "ADDITIONAL_CART_DISCOUNT_MESSAGE_SELECTORS",
  "SHOULD_USE_PRODUCT_META",
  "IS_HEADLESS_STOREFRONT",
  "ONBOARDING_TEST_FLOW",
  // "VOLUME_DISCOUNT_QUANTITY_WIDGET",
  // "VOLUME_DISCOUNT_PROGRESS_BAR_WIDGET",
  // "VOLUME_DISCOUNT_CART_MESSAGE_WIDGET",
  "DOWN_SAMPLING",
  "VIEW_ANALYTICS",
  "VIEW_SHIPPING_EXPERIMENT",
  "CREATE_SHIPPING_EXPERIMENT",
  "START_SHIPPING_EXPERIMENT",
  "EDIT_SHIPPING_EXPERIMENT",
  "VIEW_PRICE_EXPERIMENT",
  "CREATE_PRICE_EXPERIMENT",
  "START_PRICE_EXPERIMENT",
  "EDIT_PRICE_EXPERIMENT",
  "VIEW_DISCOUNT_EXPERIMENT",
  "CREATE_DISCOUNT_EXPERIMENT",
  "START_DISCOUNT_EXPERIMENT",
  "EDIT_DISCOUNT_EXPERIMENT",
  "PERSONALIZATIONS",
  "VIEW_CONTENT_EXPERIMENT",
  "CREATE_CONTENT_EXPERIMENT",
  "START_CONTENT_EXPERIMENT",
  "EDIT_CONTENT_EXPERIMENT",
  "EDIT_ADVANCED_SETTINGS",
  "VIEW_VOLUME_DISCOUNT",
  "TEST_GROUP_LIMIT",
  "PRICE_TEST_PRODUCT_LIMIT",
  "PRICE_TEST_SUBSCRIPTION_PRODUCTS",
  "PRICE_TEST_MANUAL_CSV_UPLOAD",
  "AUDIENCE_TARGETING_BASIC",
  "AUDIENCE_TARGETING_ADVANCED",
  "CONCURRENT_TESTS",
  "CREATE_COMBO_PRICE_SHIPPING_TEST",
  "SHIPPING_COST_PER_ORDER",
  "TRANSACTION_FEE_PCT",
  "AUTO_SYNC_COGS",
  "MAX_Z_SCORE",
  "DOMAIN",
  "SHOULD_USE_COOKIES",
  "METRICS_SAMPLE_RATE",
  "GA_CD_INDEX",
  "MULTI_CURRENCY_ENABLED",
  "SHOPIFY_FUNCTIONS_ENABLED",
  "SHOPIFY_FUNCTIONS_FOR_PRICING_ENABLED",
  "CART_TRANSFORM_MODE",
  "PRICE_SPLITTING_ENABLED",
  "SHOULD_MODIFY_VD_REQUESTS",
  "VIEW_NEW_DASHBOARD",
  "DISCOUNT_TITLE",
  "SHIPPING_TEST_FLAT_RATE",
  "SHIPPING_TEST_FLAT_RATE_WITH_THRESHOLD",
  "SHIPPING_TEST_THRESHOLD_ONLY",
  "SHIPPING_TEST_TIERED_RATE",
  "SHIPPING_TEST_CUSTOM_RATE",
  "SHIPPING_TEST_RATE_LIMIT",
  "USE_BROWSER_LOCALE",
  "USE_PRICE_PROPERTY",
  "USE_BEACON",
  "CSS",
  "EDIT_CURRENCY_FILTER_FOR_PRICE_TESTS",
  "EXCLUSION_GROUPS",
  "EXCLUDE_IP_ADDRESSES",
  "VIEW_DATA_RECONCILIATION_ANALYTICS",
  // "ADDITIONAL_SUBTOTAL_QUERY_SELECTORS",
  // "ADDITIONAL_LINE_ITEM_SUBTOTAL_QUERY_SELECTORS"
] as const;

export type ConfigurationKey = (typeof ConfigurationKeyList)[number];

export const ConfigurationResponseDtoSchema = z.object({
  // id: z.string().uuid(),
  organizationId: z.string().uuid(),
  key: z.string(),
  type: z.preprocess(
    (value: unknown) => (<string>value).replace("\r", ""),
    z.enum(ConfigTypeList)
  ),
  value: z.any(),
  topic: z.preprocess(
    (value: unknown) => (<string>value).replace("\r", ""),
    z.enum(ConfigTopicList)
  ),
});

export type ConfigurationDto = z.infer<typeof ConfigurationResponseDtoSchema>;
